import React, { useEffect, useState } from "react";

import ReactDOM from "react-dom";

export const PORTAL_ROOT = "portal-root";

const withDOM = <T extends unknown>(f: () => T): T | null => {
  const canUseDOM = (): boolean =>
    typeof window !== "undefined" && window.document && typeof window.document.createElement === "function";

  return canUseDOM() ? f() : null;
};

// @ts-ignore - React 18/19 type incompatibility with PropsWithChildren
export const Portalize: React.FC<React.PropsWithChildren<Readonly<Record<string, unknown>>>> = ({ children }) => {
  const [portalRoot] = useState(withDOM(() => document.getElementById(PORTAL_ROOT)));
  const [element] = useState(withDOM(() => document.createElement("div")));

  useEffect(() => {
    if (portalRoot && element) {
      portalRoot.appendChild(element);
    }

    return () => {
      if (portalRoot && element) {
        portalRoot.removeChild(element);
      }
    };
  }, [portalRoot, element]);

  if (!element) {
    return null;
  }

  // @ts-ignore - React 18/19 type incompatibility with createPortal
  return ReactDOM.createPortal(children, element);
};
